import { translateStatic } from '../translations';

export const SubscriptionTypes = {
  Free: 'FREE',
  Essentials: 'ESSENTIALS',
  Standard: 'STANDARD',
  Deluxe: 'DELUXE',
};

export const SUBSCRIPTION_TYPES_IN_ORDER = [
  SubscriptionTypes.Free,
  SubscriptionTypes.Essentials,
  SubscriptionTypes.Standard,
  SubscriptionTypes.Deluxe,
];

/**
 * @param {string} currentSubscriptionType
 * @param {string} subscriptionType
 *
 * @returns {'unknown' | 'current' | 'downgrade' | 'upgrade'}
 */
export function getSubscriptionStatus(
  currentSubscriptionType,
  subscriptionType,
) {
  const currentSubscriptionIdx = SUBSCRIPTION_TYPES_IN_ORDER.findIndex(
    (item) => item === currentSubscriptionType,
  );
  const subscriptionIdx = SUBSCRIPTION_TYPES_IN_ORDER.findIndex(
    (item) => item === subscriptionType,
  );

  if (currentSubscriptionIdx === -1 || subscriptionIdx === -1) {
    return 'unknown';
  }

  switch (true) {
    case currentSubscriptionIdx < subscriptionIdx:
      return 'upgrade';
    case currentSubscriptionIdx > subscriptionIdx:
      return 'downgrade';
    case currentSubscriptionIdx === subscriptionIdx:
    default:
      return 'current';
  }
}

/**
 * @typedef GetCheckoutLinkFnParams
 * @property {number} [discount]
 * @property {string} userEmail
 */

/**
 * @callback GetCheckoutLinkFn
 * @param {GetCheckoutLinkFnParams} params
 * @returns string
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {GetCheckoutLinkFn} getCheckoutLink
 * @property {number} messages
 * @property {number} images
 * @property {number} price
 * @property {boolean} visible
 */

/**
 *
 * @type {Plan[]}
 */
export const plans = [
  {
    id: SubscriptionTypes.Free,
    title: translateStatic('plans:plans.free.title'),
    description: translateStatic('plans:plans.free.description'),
    getCheckoutLink: () => '',
    messages: 0,
    images: 0,
    private_gfs: '',
    price: 0,
    visible: false,
  },
  {
    id: SubscriptionTypes.Essentials,
    title: translateStatic('plans:plans.essentials.title'),
    description: translateStatic('plans:plans.essentials.description'),
    getCheckoutLink: ({ userEmail }) =>
      `https://textadventure.fun/payment?type=Essentials&email=${encodeURIComponent(
        userEmail,
      )}`,
    messages: 2000,
    images: 5,
    private_gfs: '',
    price: 12,
    visible: true,
  },
  {
    id: SubscriptionTypes.Standard,
    title: translateStatic('plans:plans.standard.title'),
    description: translateStatic('plans:plans.standard.description'),
    getCheckoutLink: ({ userEmail }) =>
      `https://textadventure.fun/payment?type=Standard&email=${encodeURIComponent(
        userEmail,
      )}`,
    messages: 3000,
    images: 400,
    private_gfs: '25',
    price: 24,
    visible: true,
  },
  {
    id: SubscriptionTypes.Deluxe,
    title: translateStatic('plans:plans.deluxe.title'),
    description: translateStatic('plans:plans.deluxe.description'),
    getCheckoutLink: ({ userEmail }) =>
      `https://textadventure.fun/payment?type=Deluxe&email=${encodeURIComponent(
        userEmail,
      )}`,
    messages: 7000,
    images: 1000,
    private_gfs: '100',
    price: 49,
    visible: true,
  },
];
